module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"views":{"social_events":{"index":{"event_list":{"results_html":"<strong>0</strong> anstehende Events | <strong>1</strong> anstehendes Event | <strong>%{count}</strong> anstehende Events","past_events":"Vergangene Webinare"}}}}}}}')
  delete Component.options._Ctor
}
